import './index.css'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import SideMenu from './components/reusables/sideMenu';
import { AuthProvider, useAuth } from './auth/AuthenticationWrapper';
import Receipt from "./components/reusables/receipt";
import { useIsScreenLarge } from './utils/ViewportUtils';
import LandingPage from './pages/site/landingPage';
import LeadForm from './pages/site/contactPage';
import RegisterForm from './pages/site/registerForm';
import RequireAuth from './components/requireAuth';
import CreditReceipt from './components/reusables/creditReceipt';
import { ToastContainer } from 'react-toastify';
import Kiosk from './pages/kiosk/kiosk';
import EmailMarketingPage from './pages/foodzadmin/emailSendPage';
import AccessPage from './pages/access/access';
import Customers from './pages/customers/customers';
import PagBankAuthCallback from './pages/payments/pagbankCallback';
import Storage from './pages/storage/storage';
import Menu from './pages/menu/menu';
import StudentPage from './pages/customers/studentPage';
import ParentPage from './pages/customers/parentPage';
import EmployeePage from './pages/customers/employeePage';
import ClientPage from './pages/access/clientPage';
import PreferencesPage from './pages/access/preferencesPage';
import UserNotificationPreferencesPage from './pages/access/userNotificationPreferencesPage';
import LegalDocumentsPage from './pages/access/legalDocumentsPage';
import PasswordResetPage from './pages/site/passwordResetPage';
import LoginPage from './pages/site/loginPage';
import Orders from './pages/orders/orders';
import NewOrder from './pages/orders/newOrder';
import NewOrderCustomer from './pages/orders/newOrderCustomer';
import NewOrderParent from './pages/orders/newOrderParent';
import Financial from './pages/financial/financial';
import FinancialCustomerPage from './pages/financial/financialCustomer';
import CarteiraDigital from './pages/financial/carteiraDigital';
import Reservations from './pages/reservartions/reservations';
import ReservationsParent from './pages/reservartions/reservationsParent';
import { NotificationsProvider } from './contexts/NotificationsContext';

const PrivateRoute = ({ element: Element, roles = [], permissions = [] }) => {
    const { hasPermission } = useAuth();
    const userRole = sessionStorage.getItem("role");

    const simpleRoles = ["PARENT", "STUDENT", "EMPLOYEE"];
    const isSimpleRole = simpleRoles.includes(userRole);

    const roleOk = roles.length === 0 || roles.includes(userRole);

    const permissionsOk =
        permissions.length === 0 ||
        permissions.every(([resource, action]) =>
            hasPermission(resource, action)
        );

    let isAuthorized;

    if (isSimpleRole) {
        isAuthorized = roleOk;
    } else {
        isAuthorized = roleOk && permissionsOk;
    }

    return isAuthorized ? <Element /> : <Navigate to="/login" />;
};

function App() {
    const location = useLocation();
    const isScreenLarge = useIsScreenLarge();

    const showSideMenu = location.pathname !== '/' &&
        location.pathname !== '/contato' &&
        location.pathname !== '/redefinir-senha' &&
        !location.pathname.includes('/cadastrar') &&
        location.pathname !== '/login' &&
        !location.pathname.includes('/comprovante') &&
        !location.pathname.includes('/kiosk') &&
        isScreenLarge;

    return (
        <AuthProvider>
        <NotificationsProvider>
            <div className='min-h-screen bg-gray-50 relative'>

                {showSideMenu && <SideMenu />}
                <main
                    className={`
                        min-h-screen 
                        transition-all duration-300 
                        ${showSideMenu ? 'ml-[100px]' : 'ml-0'}
                    `}
                >
                    <div className="block">
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/contato" element={<LeadForm />} />
                            <Route path="/cadastrar/:searchInput/preencherFormulario" element={<RegisterForm />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/redefinir-senha" element={<PasswordResetPage />} />
                            <Route element={<RequireAuth />}>
                                <Route
                                    path="/termos-e-privacidade"
                                    element={<PrivateRoute element={LegalDocumentsPage} />} />
                                <Route
                                    path="/cadastro"
                                    element={<PrivateRoute element={ClientPage} roles={['ADMIN']} />} />
                                <Route
                                    path="/preferencias"
                                    element={<PrivateRoute element={PreferencesPage} roles={['ADMIN']} />} />
                                <Route
                                    path="/preferencias-usuario"
                                    element={<PrivateRoute element={UserNotificationPreferencesPage} roles={['ADMIN']} />} />
                                <Route
                                    path="/acessos-e-permissoes"
                                    element={<PrivateRoute element={AccessPage} roles={['ADMIN']} />} />
                                <Route
                                    path="/cardapio"
                                    element={<PrivateRoute element={Menu} permissions={[["menu", "view"]]} />}
                                />
                                <Route
                                    path="/estoque"
                                    element={<PrivateRoute element={Storage} permissions={[["storage", "view"]]} />} />
                                <Route
                                    path="/vendas"
                                    element={<PrivateRoute element={NewOrder} permissions={[["sales", "view"]]} />} />
                                <Route
                                    path="/comprovante"
                                    element={<PrivateRoute element={Receipt} />} />
                                <Route
                                    path="/comprovanteRecarga"
                                    element={<PrivateRoute element={CreditReceipt} />} />
                                <Route
                                    path="/pedidos"
                                    element={<PrivateRoute element={Orders} permissions={[["orders", "view"]]} />} />
                                <Route
                                    path="/clientes"
                                    element={<PrivateRoute element={Customers} permissions={[["customers", "view"]]} />} />
                                <Route
                                    path="/clientes/detalhesCliente/:searchInput"
                                    element={<PrivateRoute element={StudentPage} permissions={[["customers", "view"]]} />} />
                                <Route
                                    path="/clientes/detalhesResponsavel/:searchInput"
                                    element={<PrivateRoute element={ParentPage} roles={['PARENT']} permissions={[["customers", "view"]]} />} />
                                <Route
                                    path="/clientes/detalhesColaborador/:searchInput"
                                    element={<PrivateRoute element={EmployeePage} permissions={[["customers", "view"]]} />} />
                                <Route
                                    path="/financeiro"
                                    element={<PrivateRoute element={Financial} permissions={[["financial", "view"]]} />} />
                                <Route
                                    path="/carteira-digital"
                                    element={<PrivateRoute element={CarteiraDigital} roles={['ADMIN']} permissions={[["wallet", "view"]]} />} />
                                <Route
                                    path="/financeiroCliente/:searchInput"
                                    element={<PrivateRoute element={FinancialCustomerPage} roles={['PARENT']} />} />
                                <Route
                                    path="/novacompra"
                                    element={<PrivateRoute element={NewOrderCustomer} roles={['STUDENT']} />} />
                                <Route
                                    path="/kiosk"
                                    element={<PrivateRoute element={Kiosk} />} />
                                <Route
                                    path="/novacompra/responsavel"
                                    element={<PrivateRoute element={NewOrderParent} roles={['PARENT']} />} />
                                <Route
                                    path="/reservas"
                                    element={<PrivateRoute element={Reservations} permissions={[["reservations", "view"]]} />} />
                                <Route
                                    path="/reservas/responsavel"
                                    element={<PrivateRoute element={ReservationsParent} roles={['PARENT']} />} />
                                <Route path="/retorno-pagbank" element={<PagBankAuthCallback />} roles={['ADMIN']} />
                                <Route path="/email" element={<EmailMarketingPage />} />
                            </Route>
                        </Routes>
                    </div>
                </main>
                <ToastContainer position="bottom-right" autoClose={3000} />
            </div>
        </NotificationsProvider>
        </AuthProvider>
    );
}

export default App;